import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, logout as apiLogout, getSettings } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const me = await fetchMe();
      setUser(me);
      try {
        const s = await getSettings();
        setSettings(s);
      } catch (err) {
        console.error("Failed to load settings", err);
      }
    } catch (err) {
      console.warn("Auth check failed (likely not signed in)", err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try {
      await apiLogout();
    } catch (err) {
      console.warn("Logout request failed", err);
    }
    setUser(null);
    window.location.href = "/login";
  };

  const refreshSettings = async () => {
    try {
      const s = await getSettings();
      setSettings(s);
    } catch (err) {
      console.error("refreshSettings failed", err);
    }
  };

  return (
    <AuthCtx.Provider
      value={{ user, setUser, settings, setSettings, refreshSettings, loading, checkAuth, logout }}
    >
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
